<button class="btn source_i_btn">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.SOURCE' | translate }}">exit_to_app</i>
</button>